import { Divider, Text } from '$components'
import { LogoIcon } from '$components'

export function InvitationFooter() {

  return (
    <div className="mt-12 w-full">
      <Divider />

      <div className="mt-8 flex flex-col">
        <LogoIcon className="w-24 h-fit mb-4" />

        <Text
          type="s"
          className="text-gray-500 font-light"
        >
          Less admin, more grooming.
        </Text>
      </div>
    </div>
  )
}
